<template>
  <div id="inventory-view">
    <v-app id="inspire">
      <v-data-table
        :headers="headers"
        :items="inventories"
        sort-by="cost"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar
            flat
            color="white"
          >
            <v-toolbar-title>Inventory</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            />
            <v-spacer />
            <v-dialog
              v-model="dialog"
              max-width="500px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  New Item
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="text-h5">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-text-field
                          v-model="editedItem.name"
                          label="Device Name"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-text-field
                          v-model="editedItem.owner_name"
                          label="Owner"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-select
                          :items="['Good', 'Damaged', 'Need Repair']"
                          :menu-props="{ top: true, offsetY: true }"
                          v-model="editedItem.wearStatus"
                          label="Wear"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-text-field
                          v-model="editedItem.cost"
                          label="Cost"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="close"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="save"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.wearStatus="{ item }">
          <v-chip
            :color="getColor(item.wearStatus)"
            dark
          >
            {{
              item.wearStatus
            }}
          </v-chip>
        </template>
        <template v-slot:item.cost="{ item }">
          {{ formatPrice(item.cost) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn
            color="primary"
            @click="initialize"
          >
            Reset
          </v-btn>
        </template>
      </v-data-table>
    </v-app>
  </div>
</template>

<script>
  export default {
    name: 'InventoryView',

    data: () => ({
      dialog: false,
      headers: [
        {
          text: 'Device Name',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'Owner', value: 'owner_name' },
        { text: 'Wear', value: 'wearStatus' },
        { text: 'Cost', value: 'cost' },
        { text: 'Invoice', value: 'click' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      inventories: [],
      editedIndex: -1,
      editedItem: {
        owner_name: '',
        wearStatus: '',
        cost: 0,
        click: 'Click here',
      },
      defaultItem: {
        owner_name: '',
        wearStatus: '',
        cost: 0,
        click: 'Click here',
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.inventories = [
          {
            name: 'Mac Book Pro',
            owner_name: 'John A.',
            wearStatus: 'Good',
            cost: 1400,
            click: 'Click here',
          },
          {
            name: 'Gaming Mouse',
            owner_name: 'Ellie C.',
            wearStatus: 'Damaged',
            cost: 30,
            click: 'Click here',
          },
          {
            name: 'Gaming Desk',
            owner_name: 'Cho B.',
            wearStatus: 'Need Repair',
            cost: 50,
            click: 'Click here',
          },
          {
            name: 'Headphone',
            owner_name: 'David D.',
            wearStatus: 'Good',
            cost: 60,
            click: 'Click here',
          },
          {
            name: 'Gaming Microphone',
            owner_name: 'Ellie C.',
            wearStatus: 'Good',
            cost: 25,
            click: 'Click here',
          },
        ]
      },

      editItem (item) {
        this.editedIndex = this.inventories.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.inventories.indexOf(item)
        confirm('Are you sure you want to delete this item?') &&
          this.inventories.splice(index, 1)
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.inventories[this.editedIndex], this.editedItem)
        } else {
          this.inventories.push(this.editedItem)
        }
        this.close()
      },
      getColor (wearStatus) {
        if (wearStatus === 'Damaged') return 'red'
        else if (wearStatus === 'Need Repair') return 'orange'
        else return 'green'
      },
      formatPrice (value) {
        const val = (value / 1).toFixed(2).replace('.', ',')
        return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
    },
  }
</script>
